import React, { Component } from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import { DateRangeFilter, filterByDate, sortRecords, SortableHeader, paginate, Pagination, defaultRange } from './LogTableHelpers';

dayjs.locale('th');

const EVENT_META = {
    LOGIN: { label: 'เข้าสู่ระบบ', color: '#28a745', icon: 'fas fa-sign-in-alt' },
    LOGIN_FAIL: { label: 'Login ล้มเหลว', color: '#dc3545', icon: 'fas fa-times-circle' },
    LOGOUT: { label: 'ออกจากระบบ', color: '#6c757d', icon: 'fas fa-sign-out-alt' },
    PAGE_VIEW: { label: 'เปิดหน้า', color: '#17a2b8', icon: 'fas fa-eye' }
};

export class AuditLog extends Component {
    constructor(props) {
        super(props);
        var dr = defaultRange();
        this.state = { list: [], loading: true, search: '', eventFilter: '', selected: null,
            from: dr.from, to: dr.to, sortField: 'timestamp', sortDir: 'desc', page: 1, pageSize: 25 };
    }

    componentDidMount() { this.load(); }

    load() {
        this.setState({ loading: true });
        var q = this.state.eventFilter ? '?eventType=' + encodeURIComponent(this.state.eventFilter) : '';
        fetch('api/auditlog' + q)
            .then(r => r.ok ? r.json() : [])
            .then(list => this.setState({ list, loading: false }))
            .catch(() => this.setState({ loading: false }));
    }

    getFiltered() {
        var { list, search, from, to } = this.state;
        var r = filterByDate(list, from, to, 'timestamp');
        if (search.trim()) {
            var s = search.trim().toLowerCase();
            r = r.filter(l =>
                (l.username || '').toLowerCase().includes(s) ||
                (l.displayName || '').toLowerCase().includes(s) ||
                (l.target || '').toLowerCase().includes(s) ||
                (l.detail || '').toLowerCase().includes(s) ||
                (l.ip || '').toLowerCase().includes(s));
        }
        return r;
    }

    render() {
        var { loading, search, eventFilter, list, selected, from, to, sortField, sortDir, page, pageSize } = this.state;
        var filtered = this.getFiltered();
        var sorted = sortRecords(filtered, sortField, sortDir);
        var pageItems = paginate(sorted, page, pageSize);
        var todayLogins = list.filter(l => l.eventType === 'LOGIN' && dayjs(l.timestamp).isSame(dayjs(), 'day')).length;

        return (
            <div style={{ padding: 20 }}>
                <div className="d-flex justify-content-between align-items-center mb-3" style={{ flexWrap: 'wrap', gap: 10 }}>
                    <p style={{ margin: 0, fontSize: 13, color: '#888' }}>
                        ทั้งหมด {filtered.length} รายการ · Login วันนี้ <strong style={{ color: '#28a745' }}>{todayLogins}</strong> ครั้ง
                    </p>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => this.load()}><i className="fas fa-sync"></i> รีเฟรช</button>
                </div>

                <div style={{ background: '#fff', borderRadius: 10, padding: 14, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', marginBottom: 16 }}>
                    <div className="d-flex flex-wrap" style={{ gap: 8, marginBottom: 10 }}>
                        <button className={'btn btn-sm ' + (eventFilter === '' ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ eventFilter: '', page: 1 }, () => this.load())}>ทั้งหมด</button>
                        {Object.keys(EVENT_META).map(k => {
                            var m = EVENT_META[k];
                            return <button key={k} className={'btn btn-sm ' + (eventFilter === k ? 'btn-dark' : 'btn-outline-secondary')} onClick={() => this.setState({ eventFilter: k, page: 1 }, () => this.load())}>
                                <i className={m.icon} style={{ color: m.color }}></i> {m.label}
                            </button>;
                        })}
                        <div className="input-group" style={{ maxWidth: 320, marginLeft: 'auto' }}>
                            <span className="input-group-text" style={{ background: '#fff' }}><i className="fas fa-search" style={{ color: '#aaa' }}></i></span>
                            <input className="form-control" placeholder="ค้นหา user / target / IP" value={search} onChange={e => this.setState({ search: e.target.value, page: 1 })} style={{ borderLeft: 'none' }} />
                        </div>
                    </div>
                    <DateRangeFilter from={from} to={to} onChange={(f, t) => this.setState({ from: f, to: t, page: 1 })} />
                </div>

                {loading ? (
                    <div className="text-center py-5"><div className="spinner-border text-danger"></div></div>
                ) : filtered.length === 0 ? (
                    <div className="text-center py-5" style={{ color: '#bbb' }}>
                        <i className="fas fa-history" style={{ fontSize: 48, display: 'block', marginBottom: 12 }}></i>
                        ยังไม่มีประวัติ
                    </div>
                ) : (
                    <div style={{ background: '#fff', borderRadius: 10, boxShadow: '0 2px 12px rgba(0,0,0,0.06)', overflow: 'hidden' }}>
                        <table className="table table-hover" style={{ margin: 0 }}>
                            <thead style={{ background: '#f8f9fa' }}>
                                <tr>
                                    <SortableHeader label="เวลา" field="timestamp" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={160} />
                                    <SortableHeader label="Event" field="eventType" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={130} />
                                    <SortableHeader label="ผู้ใช้งาน" field="username" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={190} />
                                    <SortableHeader label="Target / รายละเอียด" field="target" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} />
                                    <SortableHeader label="IP" field="ip" sortField={sortField} sortDir={sortDir} onSort={(f,d)=>this.setState({sortField:f,sortDir:d})} width={130} />
                                </tr>
                            </thead>
                            <tbody>
                                {pageItems.map(l => {
                                    var m = EVENT_META[l.eventType] || { label: l.eventType, color: '#888', icon: 'fas fa-circle' };
                                    return (
                                        <tr key={l.id} style={{ cursor: 'pointer' }} onClick={() => this.setState({ selected: l })}>
                                            <td style={{ fontSize: 12, color: '#555', whiteSpace: 'nowrap' }}>
                                                <i className="far fa-clock" style={{ color: '#bbb', marginRight: 4 }}></i>
                                                {l.timestamp ? dayjs(l.timestamp).format('DD MMM YY HH:mm:ss') : '-'}
                                            </td>
                                            <td><span style={{ background: m.color, color: '#fff', padding: '3px 10px', borderRadius: 12, fontSize: 11, fontWeight: 700 }}><i className={m.icon}></i> {m.label}</span></td>
                                            <td>
                                                <div style={{ fontSize: 13, fontWeight: 600 }}><i className="fas fa-user-circle" style={{ color: '#aaa', marginRight: 4 }}></i>{l.username || '-'}</div>
                                                {l.displayName && <div style={{ fontSize: 11, color: '#888' }}>{l.displayName}</div>}
                                            </td>
                                            <td style={{ fontSize: 12, color: '#555', maxWidth: 400, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                {l.target && <code style={{ color: '#dc3545', background: '#fff5f5', padding: '1px 6px', borderRadius: 3, fontSize: 11 }}>{l.target}</code>}
                                                {l.detail && <span style={{ marginLeft: 6, color: '#777' }}>— {l.detail}</span>}
                                            </td>
                                            <td style={{ fontSize: 11, color: '#888', whiteSpace: 'nowrap' }}>{l.ip || '-'}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <Pagination total={sorted.length} page={page} pageSize={pageSize}
                            onPageChange={p => this.setState({ page: p })}
                            onPageSizeChange={s => this.setState({ pageSize: s, page: 1 })} />
                    </div>
                )}

                {selected && (
                    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }} onClick={() => this.setState({ selected: null })}>
                        <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: '90%', maxWidth: 600, maxHeight: '90vh', overflowY: 'auto' }} onClick={e => e.stopPropagation()}>
                            <div className="d-flex justify-content-between align-items-start mb-3">
                                <h5 style={{ margin: 0 }}>ประวัติ #{selected.id}</h5>
                                <button className="btn btn-sm btn-outline-secondary" onClick={() => this.setState({ selected: null })}>×</button>
                            </div>
                            <table className="table table-sm" style={{ fontSize: 13 }}>
                                <tbody>
                                    <tr><td style={{ color: '#888', width: 130 }}>เวลา</td><td>{selected.timestamp ? dayjs(selected.timestamp).format('DD MMMM YYYY HH:mm:ss') : '-'}</td></tr>
                                    <tr><td style={{ color: '#888' }}>Event</td><td><strong>{selected.eventType}</strong></td></tr>
                                    <tr><td style={{ color: '#888' }}>Username</td><td>{selected.username || '-'}</td></tr>
                                    <tr><td style={{ color: '#888' }}>ชื่อ</td><td>{selected.displayName || '-'}</td></tr>
                                    <tr><td style={{ color: '#888' }}>Target</td><td><code>{selected.target || '-'}</code></td></tr>
                                    <tr><td style={{ color: '#888' }}>Detail</td><td>{selected.detail || '-'}</td></tr>
                                    <tr><td style={{ color: '#888' }}>IP</td><td>{selected.ip || '-'}</td></tr>
                                    <tr><td style={{ color: '#888' }}>User Agent</td><td style={{ fontSize: 11, wordBreak: 'break-all', color: '#666' }}>{selected.userAgent || '-'}</td></tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
